module.exports = __webpack_public_path__ + "img/cover-3.5f21b352.jpg";